import { useEffect, useState } from "react";

type UsePageVisibilityProps = {
  isPageVisible: boolean;
  loadNavigation: () => void;
};

// If page was not visible due to using other tab, window minimised etc and is now visible
export const usePageVisibility = ({
  isPageVisible,
  loadNavigation,
}: UsePageVisibilityProps) => {
  const [prevIsPageVisible, setPrevIsPageVisible] = useState(isPageVisible);

  // load navigation to trigger a refresh of the competitions content
  useEffect(() => {
    if (isPageVisible && !prevIsPageVisible) {
      loadNavigation();
    }
    setPrevIsPageVisible(isPageVisible);
  }, [isPageVisible, prevIsPageVisible, loadNavigation]);

  return { prevIsPageVisible };
};
